<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <b-card style="border: 0" class="mt-0 mb-0 common-card">
      <h3>کد نشست تخصصی: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت نشست تخصصی: {{ proposal.status }}</h4>
      <hr />
      <v-btn
        class="float-end bc-purple text-capitalize"
        elevation="0"
        v-if="tabIndex == 0"
        variant="primary"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o white--text pe-1"></i>
        <span class="white--text"> دریافت Word</span>
      </v-btn>
      <!-- docx -->
      <div v-show="false" id="doc">
        <div class="all" style="text-align: right">
          <h1
            style="
              display: inline-block;
              text-align: center;
              padding: 5px 0;
              border-bottom: 3px solid black;
            "
          >
            کد نشست تخصصی:
            <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
              proposal.requestsCode
            }}</span>
          </h1>
          <div>
            <h2 style="color: black; direction: rtl">
              تاریخ خروجی:
              <span style="direction: ltr">{{ proposal.registerDate }}</span>
            </h2>
            <hr />
            <h2 style="display: inline-block; text-align: center; color: blue">
              عنوان و حمایت‌های پیشین
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان نشست: </strong>{{ proposal.faSubject }}
                </li>
                <li
                  :class="
                    proposal.initialIsSupported != null ? 'done' : 'required'
                  "
                >
                  <strong
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟
                  </strong>

                  {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                </li>

                <li
                  v-if="proposal.initialIsSupported"
                  :class="proposal.initialSupportedType ? 'done' : 'required'"
                >
                  <strong> حمایت ها: </strong
                  >{{
                    proposal.initialSupportedType
                      ? options.filter(
                          (x) => x.value == proposal.initialSupportedType
                        )[0].text
                      : ""
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                  :class="proposal.initialOtherSupport ? 'done' : 'required'"
                >
                  <strong>عنوان حمایت دریافتی: </strong>
                  {{ proposal.initialOtherSupport }}
                </li>
                <li
                  v-if="proposal.initialIsSupported"
                  :class="
                    proposal.initialSupportDescription ? 'done' : 'required'
                  "
                >
                  <strong>توضیحات حمایت دریافتی: </strong>
                  {{ proposal.initialSupportDescription }}
                </li>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.meetingSponsors"
                  :fields="sponsorFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات اصلی دوره
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان نشست تخصصی: </strong>{{ proposal.faSubject }}
                </li>
                <li :class="proposal.meetingGoals ? 'done' : 'required'">
                  <strong>هدف از برگزاری نشست: </strong
                  >{{ proposal.meetingGoals }}
                </li>
                <li :class="proposal.meetingPlace ? 'done' : 'required'">
                  <strong>مکان برگزاری نشست: </strong
                  >{{ proposal.meetingPlace }}
                </li>
                <li :class="proposal.universityId ? 'done' : 'required'">
                  <strong>دانشگاه محل برگزاری نشست: </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.universityId == notUniversity"
                  :class="proposal.otherUniversity ? 'done' : 'required'"
                >
                  <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                </li>
                <li
                  v-if="proposal.mehvarId != notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور طرح: </strong>
                  {{ mehvarr }}
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور طرح: </strong> سایر محورها
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.otherMehvars ? 'done' : 'required'"
                >
                  <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong>حوزه طرح: </strong>
                  <ul>
                    <li v-if="proposal.zoneMedicine">پزشکی</li>
                    <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                    <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                    <li v-if="proposal.zoneIndustrial">صنعتی</li>
                    <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                    <li v-if="proposal.zoneOther">سایر</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات مجری برگزار کننده نشست
            </h2>
            <div>
              <ul>
                <li :class="proposal.researcherName ? 'done' : 'required'">
                  <strong>نام: </strong>{{ proposal.researcherName }}
                </li>
                <li :class="proposal.researcherLastName ? 'done' : 'required'">
                  <strong>نام خانوادگی: </strong
                  >{{ proposal.researcherLastName }}
                </li>
                <li :class="proposal.researcherNatCode ? 'done' : 'required'">
                  <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                </li>
                <li :class="proposal.researcherMobile ? 'done' : 'required'">
                  <strong>تلفن همراه: </strong>{{ proposal.researcherMobile }}
                </li>
                <li :class="proposal.researcherFax ? 'done' : 'required'">
                  <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                </li>
                <li :class="proposal.researcherEmail ? 'done' : 'required'">
                  <strong>پست الکترونیکی: </strong
                  >{{ proposal.researcherEmail }}
                </li>
                <li :class="proposal.researcherState ? 'done' : 'required'">
                  <strong>استان: </strong>{{ proposal.researcherState }}
                </li>
                <li :class="proposal.researcherCity ? 'done' : 'required'">
                  <strong>شهر: </strong>{{ proposal.researcherCity }}
                </li>
                <li
                  :class="proposal.researcherUniversityId ? 'done' : 'required'"
                >
                  <strong>دانشگاه محل تحصیل: </strong>
                  {{
                    proposal.researcherUniversityId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li
                  :class="
                    proposal.researcherUniversityOther ? 'done' : 'required'
                  "
                  v-if="proposal.researcherUniversityId == notUniversity"
                >
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityOther }}
                </li>
                <li>
                  <strong>دانشگاه محل اشتغال به عنوان عضوهئیت علمی: </strong>
                  {{
                    proposal.researcherUniversityJobId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityJobId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityJobId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li
                  :class="proposal.researcherLastDegree ? 'done' : 'required'"
                >
                  <strong>آخرین مدرک تحصیلی: </strong
                  >{{ proposal.researcherLastDegree }}
                </li>
                <li>
                  <strong style="color: blue"
                    >نشست های تخصصی برگزار شده:
                  </strong>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.researcherMeetings"
                    :fields="meetingFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </li>
                <li>
                  <strong style="color: blue">کارگاه های برگزار شده: </strong>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.researcherWorkshops"
                    :fields="workshopFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              برگزار کنندگان
            </h2>
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="proposal.colleagues"
              :fields="organizersFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              زمان‌بندی
            </h2>
            <div>
              <strong>زمان شروع: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>زمان پایان: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>مدت زمان: </strong>
              {{
                proposal.gantData.length > 0
                  ? (Math.max(
                      ...proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                      3600 /
                      24 /
                      1000 +
                    " روز"
                  : ""
              }}
              <br />
            </div>
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="proposal.gantData"
              :fields="serviceFieldsDoc"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              تعهدات
            </h2>
            <div>
              <ul>
                <li v-if="proposal.promiseArrays[0]">
                  با توجه به آیین نامه تمامی مستندات در پایان نشست در سامانه
                  بارگذاری خواهد شد.
                </li>
                <li v-if="proposal.promiseArrays[1]">
                  گزارش برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه می
                  شود.
                </li>
                <li v-if="proposal.promiseArrays[2]">
                  عکس های برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه می
                  شود می‌باشد.
                </li>
                <li v-if="proposal.promiseArrays[3]">
                  پوستر نشست قبل از چاپ به تایید گروه پژوهش خواهد رسید.
                </li>
                <li v-if="proposal.promiseArrays[4]">
                  متن خبر پیش از برگزاری جهت درج در سایت به همراه پوستر تایید
                  شده به گروه پژوهش ارسال می شود.
                </li>
                <li v-if="proposal.promiseArrays[5]">
                  هماهنگی مناسب با ناظر نشست صورت خواهد گرفت.
                </li>
                <li v-if="proposal.promiseArrays[6]">
                  پذیرایی از شرکت کنندگان طبق آیین نامه صورت خواهد گرفت.
                </li>
                <li v-if="proposal.promiseArrays[7]">
                  گواهی نامه ها طبق آیین نامه و با هماهنگی گروه پژوهش تهیه و در
                  اختیار شرکت کنندگان قرار می گیرد.
                </li>
                <li v-if="proposal.promiseArrays[8]">
                  لینک اخبار و مستندات و گزارش ها روی سامانه بارگذاری خواهد شد.
                </li>
                <li v-if="proposal.promiseArrays[9]">
                  کتابچه برگزاری نشست با هماهنگی گروه پژوهش تهیه و در اختیار
                  ستاد قرار می گیرد.
                </li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <!-- docx -->
      <b-tabs class="mt-8" pills v-model="tabIndex">
        <b-tab title="چکیده طرح" lazy>
          <Meeting
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :companies="companies"
            :isLoaded="isLoaded"
          />
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <Files :files="proposal.uploadedFiles" :isLoaded="isLoaded" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
// NOTE (FUNCTION) to check validation of the email address

import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Meeting from "./../../components/AcceleratorMeeting";
import Files from "./../../components/UploadedFiles";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    Meeting,
    Files,
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      oldData: [],
      expireDisable: false,
      adminToReferee: "",
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",

      moment: moment,
      checkbox: "",
      checkbox2: "",
      show: false,
      busy: false,
      fileBusy: false,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      acc: 0,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        initialIsSupported: null,
      },
      pageLoaded: false,
      promises: {},
      colleague: {},
      universities: [],
      mehvars: [],
      dateFrom: moment(new Date()).format("jYYYY/jMM/jDD"),
      dateTo: moment(new Date()).format("jYYYY/jMM/jDD"),
      zone: new Array(6).fill(false),
      achievmentitems: [],
      tabIndex: 0,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      rejectMessage: "",
      dr: {},
      selectedMehvar: 0,
      taahol: "",
      isLoaded: true,
      DoiItem: [],
      inputs: [
        {
          name: "",
        },
      ],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      sponsorFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام حامی" },
      ],
      file: null,
      fileFilter: "",
      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],

      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
        { key: "operation", label: "" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      meetingFields: [
        { key: "index", label: "ردیف" },
        { key: "meetingSubject", label: "عنوان نشست" },
        { key: "meetingPlace", label: "محل برگزاری" },
        { key: "meetingDate", label: "تاریخ برگزاری" },
        { key: "supporterOrg", label: "سازمان حمایت کننده" },
      ],
      workshopFields: [
        { key: "index", label: "ردیف" },
        { key: "workshopSubject", label: "عنوان کارگاه برگزار شده" },
        { key: "workshopPlace", label: "محل برگزاری" },
        { key: "workshopDate", label: "تاریخ برگزاری" },
        { key: "workshopSupporterOrg", label: "سازمان حمایت کننده" },
      ],
      organizersFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "position", label: "سمت" },
        { key: "mobile", label: "شماره تماس" },
        { key: "email", label: "ایمیل" },
      ],
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      reviewers: [],
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
    };
  },

  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.proposal = {
        adminMessage: "",
        meetingGoals: "هدف تستی",
        meetingPlace: "مکان تستی",
        startDate: "1401/02/20",
        finalDate: "1401/02/21",
        meetingSponsors: [{ name: "مهیار احمدپور" }],
        certificateSupervisorFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987819432Abstract-hd-wallpapers-1080p.jpg",
        certificateSupervisorFileId: "6277556be3c2e22524009114",
        companyContactInfo: "آدرس",
        companyDescription: "توضیحات",
        companyId: "61d1a695cc60c901580c6151",
        companyName: "معروفی",
        companyNationalId: "0019936982",
        companyProducts: "معرفی",
        companyRegistrationNumber: "44456",
        comprehensiveTestFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987775573ppk-pms-v2.pdf",
        comprehensiveTestFileId: "6277553fe3c2e225240090a2",
        enSubject: "parnia opportunity test",
        faSubject: "فرصت تستی پرنیا",
        fastSub: false,
        foreignTeacherResumeFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987762032drugApp.pdf",
        researcherMeetings: [
          {
            meetingDate: "1401/02/18",
            meetingPlace: "محل 1",
            meetingSubject: "عنوان 1",
            supporterOrg: "سازمان 1",
          },
        ],
        researcherWorkshops: [
          {
            workshopDate: "1401/02/14",
            workshopPlace: "محل 3",
            workshopSubject: "عنوان 3",
            workshopSupporterOrg: "سازمان 3",
          },
        ],
        gantData: [
          {
            cellColor: "#D33115",
            description: "فعالیت تستی",
            dueDate: "1401/02/19",
            percent: "100",
            startDate: "1400/12/01",
          },
        ],
        hindexFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987768763vueRouter-query.docx",
        hindexFileId: "62775538e3c2e2252400908f",
        history: [
          {
            date: "1401/02/18",
            message:
              'وضعیت درخواست "فرصت مطالعاتی" توسط "ناصری" به "تایید نهایی" تغییر داده شد./توضیحات: "تست"',
            name: "ناصری",
            timeStamp: "1651988557",
          },
        ],
        initialIsSupported: true,
        initialObligation: true,
        initialOtherSupport: "حمایت سایر تستی",
        initialSupportDescription:
          "توضیحات برای سایر تستی به عنوان حمایت دریافت شده!",
        initialSupportedType: "other",
        invitationDestinationCountryFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987791578drugApp.pdf",
        invitationDestinationCountryFileId: "6277554fe3c2e225240090db",
        isArchive: false,
        lastUpdated: "",
        letterCompanyFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987831091164182244320415212c298b7e816e7fc10a235110f047.jpg",
        letterCompanyFileId: "62775577e3c2e2252400913a",
        letterRequestDeputyResearchFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987825068Abstract-hd-wallpapers-1080p.jpg",
        letterRequestDeputyResearchFileId: "62775571e3c2e22524009127",
        mehvarId: "1",
        minutesDefenceFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987781520drugApp.pdf",
        minutesDefenceFileId: "62775545e3c2e225240090b5",
        onWayTicketFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987800541@Wallpaper_4K3D (5475).jpg",
        onWayTicketFileId: "62775559e3c2e225240090ee",
        oppurtunityAchievements: [
          { name: "دستاورد تستی 1" },
          { name: "دستاورد تستی 2" },
        ],
        oppurtunityActions: "خلاصه ای از اقدامات تستی",
        otherCompanyName: "",
        otherCompanyNationalId: "",
        otherCompanyRegistrationNumber: "",
        otherFile1:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987838218programing.jpg",
        otherFile1Description: "",
        otherFile1Id: "6277557ee3c2e2252400914d",
        otherFile1Title: "سایر مدارک تستی",
        otherFile2: "",
        otherFile2Description: "",
        otherFile2Id: "",
        otherFile2Title: "",
        otherFile3: "",
        otherFile3Description: "",
        otherFile3Id: "",
        otherFile3Title: "",
        otherMehvars: "محور تستی دانشگاه تهران مرکز",
        otherUniversity: "تهران مرکز",
        promiseArrays: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
        ],
        proposalWordFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987786858customizing color.docx",
        proposalWordFileId: "6277554ae3c2e225240090c8",
        registerDate: "1401/02/18",
        rejectionIds: [],
        requestsCode: "biodc-2002154-2002238.1",
        researcherArticleISI: [
          {
            file: {
              isUploaded: true,
              showProgress: true,
              striped: false,
              uploadButDisable: false,
              uploadPercentage: 100,
              variant: "success",
            },
            uploadedFile: {
              id: "62774e33e3c2e22524008e53",
              showName: "git-flow.pdf",
              url: "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651985971155git-flow.pdf",
            },
            magName: "تست",
            refrence: "2",
            releaseYear: "1399",
            subject: "عنوان 1",
            writersName: "آرینا شهبازی",
          },
        ],
        researcherBankName: "ملت",
        researcherCity: "تهران",
        researcherComprehensiveTestDate: "1401/02/17",
        researcherComprehensiveTestMark: "20",
        researcherCountryDestination: "ژاپن",
        researcherEmail: "parniamaroofi@gmail.com",
        researcherFax: "4455",
        researcherHindex: "2",
        researcherIBAN: "1484520",
        researcherLastName: "معروفی",
        researcherMasterStudent: "student",
        researcherMobile: "09226907483",
        researcherName: "پرنیا",
        researcherNatCode: "0019936982",
        researcherPhDThesisDefenceDate: "1401/02/18",
        researcherPhDThesisSubject: "عنوان تستی",
        researcherResumeFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987736500customizing-color.pdf",
        researcherResumeFileId: "62775518e3c2e22524009069",
        researcherState: "تهران",
        researcherUniversityDestination: "بین المللی",
        researcherUniversityId: "61540047099e14274252ea5e",
        researcherUniversityJobId: "1",
        researcherUniversityJobOther: "دانشگاه تستی",
        researcherUniversityOther: "",
        returnTicketFile: "",
        returnTicketFileId: "",
        revision: "1",
        status: "تایید نهایی",
        colleagues: [
          {
            email: "a@aa.aa",
            id: "62775609e3c2e225240091a1",
            lastDegree: "دکتری",
            lastName: "ناصری",
            mobile: "09191161279",
            name: "امیرمسعود",
            natCode: "11111111111",
            position: "سمت تستی",
            cooperationType: "تست",
            resumeFile:
              "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651986063220vueRouter-query.docx",
            resumeFileId: "62774e8fe3c2e22524008e8c",
            resumeFileName: "vueRouter-query.docx",
            universityId: "61540047099e14274252ea5e",
            universityJobId: "61540047099e14274252ea66",
            universityJobOther: "",
            universityOther: "",
          },
        ],
        typePractical: false,
        typeStudy: true,
        typeSystemicDevelopmental: false,
        universityId: "1",
        uploadedFiles: [
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
        ],
        visaFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987809735@Wallpaper_4K3D (9371).jpg",
        visaFileId: "62775566e3c2e22524009101",
        zoneAgriculture: false,
        zoneBioComputing: false,
        zoneEnvironment: false,
        zoneIndustrial: false,
        zoneMedicine: true,
        zoneOther: true,
      };
      this.pageLoaded = true;
      this.fileBusy = false;
      //   this.$bvModal.show("loading");
      //   this.isLoaded = false;
      //   this.$root.$emit("show::modal", "loading");
      //   this.fileBusy = false;
      //     let acc = 0;
      //     // accelerator universities
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/universities",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.universities = res.data;
      //         this.universities.push(
      //           new Object({
      //             id: this.notUniversity,
      //             text: "سایر دانشگاه ها",
      //           })
      //         );
      //         this.universities.unshift({
      //           id: 0,
      //           name: "--گزینه مورد نظر خود را انتخاب نمایید--",
      //           disabled: "true",
      //         });
      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator mehvars
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/uniMehvars",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.mehvars = res.data;
      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator companies
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/companies",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.companies = res.data;
      //         this.companies.forEach((x) => {
      //           x.text = x.name;
      //         });
      //         this.companies.push(
      //           new Object({
      //             id: this.notCompany,
      //             text: "سایر شرکت ها",
      //           })
      //         );

      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator reviewers
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/admin/reviewers/select",
      //         {
      //           projectId: this.$route.params.id,
      //         },
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.reviewersOptions = res.data;
      //         this.reviewersOptions.forEach((x) => {
      //           x.code = x.id;
      //           x.label = x.name;
      //         });

      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     /////////////////////////////////////////////
      //     // accelerator rejections
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/options/rejections",
      //         {},
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.rejectOptions = res.data;
      //         this.rejectOptions.forEach((x) => {
      //           x.code = x.id;
      //           x.label = x.name;
      //         });

      //         acc++;
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
      //     //////////////////////////////////////
      //     // accelerator getInfo
      //     this.$http
      //       .post(
      //         this.baseUrl + "/setad/admin/request/opportune/getInfo",
      //         {
      //           requestId: this.$route.params.id,
      //         },
      //         {
      //           headers: {
      //             Authorization: "Bearer: " + localStorage.getItem("userId"),
      //           },
      //         }
      //       )
      //       .then((res) => {
      //         this.proposal = res.data.request;
      //         this.reviews = res.data.reviews;
      //         this.selectedSituation = this.situationsOptions.filter(
      //           (x) => x.text == this.proposal.status
      //         )[0].id;
      //         acc++;
      //         if (acc > 2) {
      //           try {
      //             document.body.classList.toggle("sidebar-minimized");
      //             document.body.classList.toggle("brand-minimized");
      //             this.toast(
      //               "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
      //             );
      //           } catch {}
      //           this.$bvModal.hide("loading");
      //           this.isLoaded = true;
      //         }
      //         setTimeout(() => {
      //           // NOTE (m-setTimeout) to set timeout for 200 ms
      //           this.pageLoaded = true;
      //         }, 200);
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       });
    },
  },
  computed: {
    mehvarr() {
      let mehvarr;
      try {
        mehvarr = this.mehvars.filter((x) => x.id == this.proposal.mehvarId)[0]
          .text;
      } catch (error) {
        mehvarr = "";
      }
      return mehvarr;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.onMounted();
  },
  updated() {},
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
